import React from "react";
import _ from "lodash";
import { useQuery, gql } from "@apollo/client";
import LocationFilter from "components/LocationFilter";
import { getPrefectureCode } from "helpers/location";
import EventGroupList from "components/presentation/EventGroupList";
import useLocalStorage from "hooks/useLocalStorage";

const GET_EVENTS = gql`
  query GetEvents {
    eventGroups {
      id
      items {
        id
        dateTime
        venue {
          id
          location
        }
      }
      ...EventGroupListEventGroup
    }
  }
  ${EventGroupList.fragments.eventGroup}
`;

export default () => {
  const [selectedLocations, setSelectedLocations] = useLocalStorage(
    "event-calender/selected-locations",
    []
  );
  const { loading, error, data } = useQuery(GET_EVENTS);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  let eventGroups = data.eventGroups;

  const validPrefectures = _.uniq(
    eventGroups.reduce(
      (prev, eg) => [
        ...prev,
        ...eg.items.map((ei) => getPrefectureCode(ei.venue.location)),
      ],
      []
    )
  );

  if (selectedLocations.length > 0) {
    eventGroups = eventGroups.filter((eg) =>
      eg.items.some((ei) =>
        selectedLocations.includes(getPrefectureCode(ei.venue.location))
      )
    );
  }

  return (
    <div>
      <h1>公演情報</h1>
      <LocationFilter
        selectedValues={selectedLocations}
        onChange={setSelectedLocations}
        validPrefectures={validPrefectures}
      />
      <EventGroupList
        eventGroups={eventGroups}
        locationFilter={selectedLocations}
      />
    </div>
  );
};
